// client/src/services/configService.js

const getApiUrl = () => {
  const BASE_URL = import.meta.env.VITE_BASE_URL
  return window.location.hostname === 'localhost'
    ? 'http://localhost:7080/api'
    : `/api`;
};

export const configService = {
  
  async getAppConfig() {
    try {
      const url = `${getApiUrl()}/app-config`;
      console.log('📋 Fetching config from:', url);
      
      const response = await fetch(url);
      
      if (!response.ok) {
        console.error('❌ Config fetch failed with status:', response.status);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('📋 Config response:', data);
      
      if (data.success) {
        return data.config;
      }
      
      // Default to production mode (search disabled) if fetch fails
      return {
        productionMode: true,
        features: {
          searchEnabled: false
        }
      };
    } catch (error) {
      console.error('❌ Failed to fetch app config:', error);
      // Default to production mode (search disabled) on error
      return {
        productionMode: true,
        features: {
          searchEnabled: false
        }
      };
    }
  }
};